import { render, staticRenderFns } from "./MX.vue?vue&type=template&id=735333e0&"
import script from "./MX.vue?vue&type=script&lang=js&"
export * from "./MX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports